import React from 'react';
import debug from 'debug';
import { useLocation } from 'react-router';

const log = debug('exchange:core');

export default (Component) => {
  const WithFocusRestore = (props) => {
    const location = useLocation();

    React.useEffect(() => {
      const skipLinksElement = global.document.getElementById('skip-links');

      // Prefer the first rendered skip link `<a>` (perceivable, actionable
      // bypass control); fall back to the container only if links have not
      // portaled in yet. WCAG 2.4.1 requires the bypass mechanism to be
      // perceivable on first focus, not an empty wrapper.
      const focusFirstSkipLink = () => {
        const firstLink = skipLinksElement?.querySelector('a');
        const target = firstLink || skipLinksElement;

        if (target && document.activeElement !== target) {
          log('focusing skip links');
          target.focus();
        }
      };

      focusFirstSkipLink();
      // SkipLinks portals into #skip-links from componentDidMount; retry once
      // after children have a chance to render.
      const timeoutId = setTimeout(focusFirstSkipLink, 100);

      return () => clearTimeout(timeoutId);
    }, [location?.pathname]);

    return <Component {...props} />;
  };

  const name = Component.displayName || Component.name;

  WithFocusRestore.displayName = name
    ? `WithFocusRestore(${name})`
    : 'WithFocusRestore';

  return WithFocusRestore;
};
